import {UserGateway} from '../../../../core-logic/gateways/api-services/user-gateway';
import {Injectable} from '@angular/core';
import {PhoneSmsCodeModel} from '../../../../core-logic/models/shared/phone-sms-code-model';
import {Observable} from 'rxjs';
import {ErrorModel} from '../../../../core-logic/models/shared/error-model';
import {UserModel} from '../../../../core-logic/models/user/user-model';
import {PhonePasswordModel} from '../../../../core-logic/models/shared/phone-password-model';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {PhoneModel} from '../../../../core-logic/models/shared/phone-model';
import {UserUpdatePasswordModel} from 'src/app/core-logic/models/user/user-update-password-model';
import {MethodModel} from 'src/app/core-logic/models/user/sub/payment-model';
import {PaymentMethodAndMethodModel} from '../../../../core-logic/models/shared/payment-method-and-method-model';
import {MethodIdAuthorizedBusinessIdsModel} from 'src/app/core-logic/models/shared/method-id-authorized-business-ids-model';

@Injectable({providedIn: 'root'})
export class UserGatewayHttp implements UserGateway {

  constructor(private httpClient: HttpClient) {
  }

  confirmPhoneNumber(phoneAndSmsCodeModel: PhoneSmsCodeModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/confirm-phone-number`, phoneAndSmsCodeModel);
  }

  createUserByPhoneNumber(phoneModel: PhoneModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/register-phone-number`, {phone: phoneModel} );
  }

  createSetupIntentAndGetClientSecret(): Observable<string | ErrorModel> {
    return this.httpClient.get<string | ErrorModel>(`${environment.fydlApi.url}/api/user/setup-intent-client-secret`);
  }

  addPaymentMethod(paymentMethodModel: MethodModel): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/payment-method`, paymentMethodModel);
  }


  removePaymentMethod(methodId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.delete<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/payment-method/${methodId}`);
  }

  updatePaymentMethodAuthorizedBusiness(methodIdAuthorizedBusinessIdsModel: MethodIdAuthorizedBusinessIdsModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .put<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/payment-method`, methodIdAuthorizedBusinessIdsModel);
  }

  getPaymentMethods(): Observable<PaymentMethodAndMethodModel[] | ErrorModel> {
    return this.httpClient.get<PaymentMethodAndMethodModel[] | ErrorModel>(`${environment.fydlApi.url}/api/user/payment-methods`);
  }

  initPassword(phoneAndPasswordModel: PhonePasswordModel): Observable<UserModel | ErrorModel> {
    return this.httpClient
      .post<UserModel | ErrorModel>(`${environment.fydlApi.url}/api/init-password`, phoneAndPasswordModel);
  }

  login(phoneAndPasswordModel: PhonePasswordModel): Observable<UserModel | ErrorModel> {
    return this.httpClient
      .post<UserModel | ErrorModel>(`${environment.fydlApi.url}/api/login`, phoneAndPasswordModel);
  }

  logout(): Observable<boolean | ErrorModel> {
    return this.httpClient.get<boolean | ErrorModel>(`${environment.fydlApi.url}/api/logout`);
  }

  updatePassword(userUpdatePasswordModel: UserUpdatePasswordModel): Observable<string | ErrorModel> {
    return this.httpClient
      .put<string | ErrorModel>(`${environment.fydlApi.url}/api/user/password`, userUpdatePasswordModel);
  }

  updateFcmToken(fcmToken: string): Observable<boolean | ErrorModel> {
    return this.httpClient.put<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/fcm-token`, {fcm_token: fcmToken});
  }

  resetPassword(phoneModel: PhoneModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/reset-password/send-sms`, {phone: phoneModel});
  }

  resetPasswordConfirmation(phoneSmsCodeModel: PhoneSmsCodeModel): Observable<UserModel | ErrorModel> {
    return this.httpClient
      .post<UserModel | ErrorModel>(`${environment.fydlApi.url}/api/reset-password/confirmation`, phoneSmsCodeModel);
  }

  getGetUser(): Observable<UserModel | ErrorModel> {
    return this.httpClient.get<UserModel | ErrorModel>(`${environment.fydlApi.url}/api/user`);
  }

  updatePhoneNumber(phoneModel: PhoneModel): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/update-phone`, {phone: phoneModel} );
  }

  updatePhoneNumberConfirmation(smsCode: number): Observable<boolean | ErrorModel> {
    return this.httpClient
      .post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/confirm-update-phone`, {sms_code: smsCode} );
  }

  deleteUser(phonePasswordModel: PhonePasswordModel): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/user/delete`, phonePasswordModel );
  }
}
